'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class annexModel extends ngDepModel
{

	flow;
	
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	getValue(name){
		switch(name){
			case 'explain':
				return this.s('$filter')('nl2br')(this[name]);
			case 'created':
				return this.s('$filter')('u2date')(this[name], 'dd/MM/y HH:mm');
		}
		if(typeof(this[name]) === 'undefined' || this[name] === ''){
			return '';
		}
		return this[name];
	}
	
	getAnnexValue(name){
		if(typeof(this.annex[name]) === 'undefined' || this.annex[name] === ''){
			return this.getValue(name);
		}
		switch(name){
			case 'explain':
				return this.s('$filter')('nl2br')(this.annex[name]);
			case 'created':
				return this.s('$filter')('u2date')(this.annex[name], 'dd/MM/y HH:mm');
		}

		return this.annex[name];
	}
}